import classNames from "classnames";
import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { IUser } from "../../../models/user";
import { useAppSelector } from "../../../store/reducers";
import { Step } from "../constants";

type IProps = Immutable<{
    user: IUser;
    onEdit?: (event?: React.MouseEvent<HTMLElement>) => void;
}>;

export const EmailAddressSummary = (props: IProps): React.ReactNode => {
    const showSummary = useAppSelector(
        (state) => state.checkout.form.current_step > Step.LOGIN,
    );

    const summaryClasses = classNames({
        "checkout-step__summary": true,
        "checkout-step__summary--collapsed": !showSummary,
    });
    return (
        <div className={summaryClasses}>
            {/* TODO(i18n): Include punctuation in translation string: t`Logged in as ${props.user.email}.` */}
            <p>{t`Logged in as ${props.user.email}`}</p>
            {props.onEdit && (
                <p>
                    <a
                        className="checkout-step__back"
                        href="#"
                        onClick={props.onEdit}
                    >
                        {t`Edit`}
                    </a>
                </p>
            )}
        </div>
    );
};
